import { render } from "./LegacyPointSelectTree.vue?vue&type=template&id=aa9538de&scoped=true"
import script from "./LegacyPointSelectTree.vue?vue&type=script&lang=js"
export * from "./LegacyPointSelectTree.vue?vue&type=script&lang=js"

import "./LegacyPointSelectTree.vue?vue&type=style&index=0&id=aa9538de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9538de"]])

export default __exports__